export const FIREBASE_ERROR_MESSAGES: Record<string, string> = {
  'auth/email-already-exists':
    'Otro usuario ya está utilizando el correo electrónico proporcionado.',
  'auth/id-token-expired':
    'El token de ID de Firebase proporcionado está vencido.',
  'auth/id-token-revoked': 'El token de ID de Firebase fue revocado.',
  'auth/insufficient-permission':
    'La credencial usada no tiene permisos suficientes para acceder al recurso solicitado.',
  'auth/internal-error':
    'Se produjo un error interno en el servidor de autenticación. Inténtalo de nuevo más tarde.',
  'auth/invalid-argument':
    'Se proporcionó un argumento no válido al método de autenticación.',
  'auth/invalid-credential':
    'La credencial usada no es válida para la acción deseada.',
  'auth/invalid-disabled-field':
    'El valor de la propiedad "disabled" no es válido. Debe ser booleano.',
  'auth/invalid-display-name':
    'El nombre de usuario no es válido. Debe ser una cadena no vacía.',
  'auth/invalid-email': 'El correo electrónico no es válido.',
  'auth/invalid-email-verified':
    'El valor de "emailVerified" no es válido. Debe ser booleano.',
  'auth/invalid-id-token': 'El token de ID proporcionado no es válido.',
  'auth/invalid-last-sign-in-time':
    'La hora del último acceso no es una fecha válida en formato UTC.',
  'auth/invalid-password':
    'La contraseña no es válida. Debe tener al menos seis caracteres.',
  'auth/invalid-password-hash':
    'El hash de contraseña no es un búfer de bytes válido.',
  'auth/invalid-phone-number':
    'El número de teléfono no es válido. Debe cumplir el estándar E.164.',
  'auth/missing-uid': 'Se requiere un uid para la operación actual.',
  'auth/missing-oauth-client-secret':
    'El secreto de cliente es obligatorio para habilitar el flujo de código de OIDC.',
  'auth/phone-number-already-exists':
    'Otro usuario ya utiliza el número de teléfono proporcionado.',
  'auth/session-cookie-expired': 'La cookie de sesión de Firebase ha expirado.',
  'auth/session-cookie-revoked':
    'La cookie de sesión de Firebase fue revocada.',
  'auth/too-many-requests':
    'Demasiadas solicitudes. Inténtalo de nuevo más tarde.',
  'auth/user-not-found': 'Usuario no encontrado.',
  'auth/wrong-password': 'La contraseña es incorrecta.',
  'auth/user-disabled': 'La cuenta del usuario está deshabilitada.',
  'auth/invalid-login-credentials':
    'Credenciales de inicio de sesión inválidas.',
  'auth/invalid-verification-code': 'El código de verificación es inválido.',
  'auth/code-expired': 'El código de verificación ha expirado.',
};

export function getFirebaseErrorMessage(code?: string): string | null {
  if (!code) return null;
  const normalized: string = code.trim();
  return FIREBASE_ERROR_MESSAGES[normalized] || null;
}
